import { Outlet } from "react-router";

import { AnnouncementBar } from "../components/layout/AnnouncementBar";
import { Footer } from "../components/layout/Footer";
import { Header } from "../components/layout/Header";

export function StorefrontLayout() {
  return (
    <div className="min-h-screen bg-[#fffdf8]">
      <AnnouncementBar />
      <Header />

      <main>
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}
